import { translate } from '../server/index-server'

export const useTranslations = () => {
  return <T extends object>(key: string, data?: T, fallback?: string): string =>
    translate(key, data, fallback)
}
